import { DateRangePicker } from "../DateRangePicker";
import { SwitchAppPopover } from "../SwitchAppPopover";
import { IDatePopOverViewProps } from "./DatePopOver";

export const View = (props: IDatePopOverViewProps) => {
  return (
    <SwitchAppPopover
      isOpen={props.isOpen}
      popoverContent={<DateRangePicker {...props} />}
      className={`date-popover ${props.className}`}
    >
      <button
        type="button"
        onClick={props.togglePopover}
        className="cds--popover--button"
      >
        {props.dateString}
      </button>
    </SwitchAppPopover>
  );
};
